<template>
    <div>
        <label class="label">Pickup color</label>
        <div class="columns is-gapless is-multiline is-mobile">
            <div class="column is-narrow is-0 is-centered"
                 v-for="color in colors"
                 @click="handleColorQuery(color.value)">
                <div class="color has-text-centered"
                     :style="[ color.styles ]"
                     :class="{ 'selected-color': isColorInQuery(color.value) }">
                    <i class="fas fa-check" v-if="isColorInQuery(color.value)"></i>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                colors: [
                    {
                        value: 'pearl',
                        active: false,
                        styles: {
                            backgroundColor: 'pearl'
                        }
                    },
                    {
                        value: 'white',
                        active: false,
                        styles: {
                            backgroundColor: 'white'
                        }
                    },
                    {
                        value: 'yellow',
                        active: false,
                        styles: {
                            backgroundColor: 'yellow'
                        }
                    },
                    {
                        value: 'orange',
                        active: false,
                        styles: {
                            backgroundColor: 'orange'
                        }
                    },
                    {
                        value: 'wine',
                        active: false,
                        styles: {
                            backgroundColor: '#722f37'
                        }
                    },
                    {
                        value: 'magenta',
                        active: false,
                        styles: {
                            backgroundColor: 'magenta'
                        }
                    },
                    {
                        value: 'purple',
                        active: false,
                        styles: {
                            backgroundColor: 'purple'
                        }
                    },
                    {
                        value: 'blue',
                        active: false,
                        styles: {
                            backgroundColor: 'blue'
                        }
                    },
                    {
                        value: 'green',
                        active: false,
                        styles: {
                            backgroundColor: 'green'
                        }
                    },
                    {
                        value: 'maroon',
                        active: false,
                        styles: {
                            backgroundColor: 'maroon'
                        }
                    },
                    {
                        value: 'beige',
                        active: false,
                        styles: {
                            backgroundColor: 'beige'
                        }
                    },
                    {
                        value: 'gold',
                        active: false,
                        styles: {
                            backgroundColor: 'gold'
                        }
                    },
                    {
                        value: 'silver',
                        active: false,
                        styles: {
                            backgroundColor: 'silver'
                        }
                    },
                    {
                        value: 'grey',
                        active: false,
                        styles: {
                            backgroundColor: 'grey'
                        }
                    },
                    {
                        value: 'black',
                        active: false,
                        styles: {
                            backgroundColor: 'black'
                        }
                    }
                ]
            }
        },
        methods: {
            handleColorQuery: function (color) {
                this.$store.dispatch('handleQueryColorStock', color)
            },
            isColorInQuery: function (color) {
                return this.$store.getters.getQueryColorStatusStock(color);
            }
        }
    }
</script>

<style scoped>
    .color {
        height: 32px;
        width: 32px;
        border: solid lightgrey 1px;
        border-radius: 6px;
        margin-right: 5px;
        margin-bottom: 5px;
        cursor: pointer;
    }
    .selected-color {
        border: 1.5px solid deepskyblue !important
    }

</style>



// WEBPACK FOOTER //
// src/components/StockCars/SpecificationColorPaletteStock.vue